var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "setup-profile-tab dashboard-tab" },
    [
      _c(
        "vuestic-wizard",
        {
          attrs: {
            steps: _vm.steps,
            "wizard-layout": "vertical",
            "wizard-type": _vm.wizardType,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "form-wizard-tab-content",
              attrs: { slot: "page1" },
              slot: "page1",
            },
            [
              _c("h4", [_vm._v("Type your name")]),
              _c("p", [
                _vm._v(
                  'Zebras communicate with facial expressions and sounds. They make loud\n        braying or barking sounds and\n        soft snorting sounds. The position of their ears, how wide open their\n        eyes are, and whether they show\n        their teeth all send a signal. For example, ears flat back means\n        trouble, or "you better follow orders!"'
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "form-group with-icon-right",
                  class: {
                    "has-error": _vm.errors.has("name"),
                    valid: _vm.isFormFieldValid("name"),
                  },
                },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        type: "text",
                        name: "name",
                        required: "required",
                      },
                      domProps: { value: _vm.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.name = $event.target.value
                        },
                      },
                    }),
                    _c("i", {
                      staticClass:
                        "fa fa-exclamation-triangle error-icon icon-right input-icon",
                    }),
                    _c("i", {
                      staticClass:
                        "fa fa-check valid-icon icon-right input-icon",
                    }),
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v("Name"),
                    ]),
                    _c("i", { staticClass: "bar" }),
                    _c(
                      "small",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("name"),
                            expression: "errors.has('name')",
                          },
                        ],
                        staticClass: "help text-danger",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.errors.first("name")) + "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "form-wizard-tab-content",
              attrs: { slot: "page2" },
              slot: "page2",
            },
            [
              _c("h4", [_vm._v("Select your country")]),
              _c("p", [
                _vm._v(
                  'Zebras communicate with facial expressions and sounds. They make loud\n        braying or barking sounds and\n        soft snorting sounds. The position of their ears, how wide open their\n        eyes are, and whether they show\n        their teeth all send a signal. For example, ears flat back means\n        trouble, or "you better follow orders!"'
                ),
              ]),
              _c("vuestic-simple-select", {
                ref: "selectedCountrySelect",
                attrs: {
                  label: "Select country",
                  name: "country",
                  required: true,
                  options: _vm.countriesList,
                },
                model: {
                  value: _vm.selectedCountry,
                  callback: function ($$v) {
                    _vm.selectedCountry = $$v
                  },
                  expression: "selectedCountry",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "form-wizard-tab-content",
              attrs: { slot: "page3" },
              slot: "page3",
            },
            [
              _c("h4", [_vm._v("Confirm selection")]),
              _c("p", [
                _vm._v(
                  '\n        Zebras communicate with facial expressions and sounds. They make loud\n        braying or barking sounds and\n        soft snorting sounds. The position of their ears, how wide open their\n        eyes are, and whether they show\n        their teeth all send a signal. For example, ears flat back means\n        trouble, or "you better follow orders!"\n      '
                ),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "form-wizard-tab-content wizard-completed-tab",
              attrs: { slot: "wizardCompleted" },
              slot: "wizardCompleted",
            },
            [
              _c("h4", [_vm._v("Wizard completed!")]),
              _c("p", [
                _vm._v(
                  '\n        Zebras communicate with facial expressions and sounds. They make loud\n        braying or barking sounds and\n        soft snorting sounds. The position of their ears, how wide open their\n        eyes are, and whether they show\n        their teeth all send a signal. For example, ears flat back means\n        trouble, or "you better follow orders!"\n      '
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }